module.exports = __webpack_public_path__ + "img/card2.16034388.svg";